import type { PriceInfo } from "epsm-api-types/ws";
import type { UTCTimestamp } from "lightweight-charts";
import { ONE_DAY_IN_MS } from "@/lib/utils";
import { PriceService } from "../../services/PriceService";
import type { Timeframes } from "../../types";
import { getDefaultParams } from "../../ui/AdvancedChart/datafeed-services/CustomIndicatorService";

export const filterDataByMainSeries = async (
	responseData: PriceInfo<UTCTimestamp>[],
	from: number,
	to: number,
	ticker: string,
	interval: Timeframes,
): Promise<PriceInfo<UTCTimestamp>[]> => {
	const responseMainSeries = await PriceService.create().getData(
		getDefaultParams(from - 7 * ONE_DAY_IN_MS, to + 7 * ONE_DAY_IN_MS, ticker),
		interval,
	);

	const filteredResponse = responseData?.filter((a) =>
		responseMainSeries.data?.some(
			(item) =>
				new Date(item.time).setUTCHours(0, 0, 0, 0) ===
				new Date(a.time).setUTCHours(0, 0, 0, 0),
		),
	);

	return filteredResponse ?? [];
};
